(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-collection-main"]) return;
  try {
    
  /* The hover loader and the touch swap now live in snippets/rf-card-hover.liquid,
     rendered from theme.liquid, so every template that uses rf-product-card gets
     them — not just this one. They were here, which is why the homepage carousel
     faded in an <img> that had never downloaded a file. */

// Within-page sort: highest stock first. Only runs when no explicit sort_by param.
(function() {
  var grid = document.getElementById('rf-products');
  if (!grid) return;
  var params = new URLSearchParams(window.location.search);
  if (params.get('sort_by')) return;
  var wraps = Array.prototype.slice.call(grid.querySelectorAll('.rf-product-wrap'));
  wraps.sort(function(a, b) {
    var aStock = parseInt(a.getAttribute('data-stock'), 10) || 0;
    var bStock = parseInt(b.getAttribute('data-stock'), 10) || 0;
    return bStock - aStock;
  });
  var frag = document.createDocumentFragment();
  wraps.forEach(function(w) { frag.appendChild(w); });
  grid.appendChild(frag);
})();

(function() {
  var form = document.getElementById('rf-filter-form');
  var products = document.querySelectorAll('.rf-product-wrap');
  var emptyMsg = document.getElementById('rf-empty-msg');
  var countEl = document.getElementById('rf-visible-count');
  var totalEl = document.getElementById('rf-total-count');
  var clearBtn = document.getElementById('rf-clear-filters');
  var emptyClear = document.getElementById('rf-empty-clear');
  if (!form || !products.length) return;
  if (totalEl) totalEl.textContent = products.length;

  function applyFilters() {
    var checkedTags = [];
    var checkedColours = [];
    var checkedMaterials = [];
    var minPrice = parseFloat(document.getElementById('rf-price-min').value) || null;
    var maxPrice = parseFloat(document.getElementById('rf-price-max').value) || null;
    var saleOnly = false;

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
      var type = cb.getAttribute('data-rf-filter');
      var val = cb.value.toLowerCase();
      if (type === 'tag') checkedTags.push(val);
      else if (type === 'colour') checkedColours.push(val);
      else if (type === 'material') checkedMaterials.push(val);
      else if (type === 'sale') saleOnly = true;
    });

    var visible = 0;
    products.forEach(function(wrap) {
      var tags = wrap.getAttribute('data-tags').split('||');
      var colour = wrap.getAttribute('data-colour') || '';
      var price = parseFloat(wrap.getAttribute('data-price')) || 0;
      var onSale = wrap.getAttribute('data-on-sale') === '1';

      var show = true;
      if (checkedTags.length && !checkedTags.some(function(t) { return tags.indexOf(t) !== -1; })) show = false;
      if (checkedColours.length && !checkedColours.some(function(c) { return colour.indexOf(c) !== -1; })) show = false;
      if (minPrice !== null && price < minPrice) show = false;
      if (maxPrice !== null && price > maxPrice) show = false;
      if (saleOnly && !onSale) show = false;

      wrap.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (countEl) countEl.textContent = visible;
    if (emptyMsg) emptyMsg.style.display = visible === 0 ? 'block' : 'none';
    updateUrl();
  }

  function updateUrl() {
    var params = new URLSearchParams();
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
      params.append(cb.getAttribute('data-rf-filter'), cb.value);
    });
    var min = document.getElementById('rf-price-min').value;
    var max = document.getElementById('rf-price-max').value;
    if (min) params.append('price-min', min);
    if (max) params.append('price-max', max);
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.replaceState({}, '', newUrl);
  }

  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      var type = cb.getAttribute('data-rf-filter');
      var values = params.getAll(type);
      if (values.indexOf(cb.value) !== -1) {
        cb.checked = true;
        var label = cb.closest('.filter-option');
        if (label) label.classList.add('checked');
        var wrap = cb.closest('.colour-filter-wrap');
        if (wrap) wrap.classList.add('active');
      }
    });
    var min = params.get('price-min'), max = params.get('price-max');
    if (min) document.getElementById('rf-price-min').value = min;
    if (max) document.getElementById('rf-price-max').value = max;
  }

  function clearAll(e) {
    if (e) e.preventDefault();
    form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      cb.checked = false;
      var label = cb.closest('.filter-option');
      if (label) label.classList.remove('checked');
      var wrap = cb.closest('.colour-filter-wrap');
      if (wrap) wrap.classList.remove('active');
    });
    document.getElementById('rf-price-min').value = '';
    document.getElementById('rf-price-max').value = '';
    applyFilters();
  }

  // Wire events
  form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
    cb.addEventListener('change', function() {
      var label = cb.closest('.filter-option');
      if (label) label.classList.toggle('checked', cb.checked);
      var wrap = cb.closest('.colour-filter-wrap');
      if (wrap) wrap.classList.toggle('active', cb.checked);
      applyFilters();
    });
  });
  ['rf-price-min', 'rf-price-max'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', applyFilters);
  });
  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  if (emptyClear) emptyClear.addEventListener('click', clearAll);

  // Init
  readUrl();
  applyFilters();
})();

(function() {
  var toggle = document.getElementById('rf-filter-toggle');
  var sidebar = document.getElementById('rf-filter-sidebar');
  if (!toggle || !sidebar) return;
  toggle.addEventListener('click', function() {
    sidebar.classList.toggle('open');
    document.body.classList.toggle('rf-drawer-locked', sidebar.classList.contains('open'));
  });
  document.addEventListener('click', function(e) {
    if (sidebar.classList.contains('open') && !sidebar.contains(e.target) && e.target !== toggle && !toggle.contains(e.target)) {
      sidebar.classList.remove('open');
      document.body.classList.remove('rf-drawer-locked');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-header"]) return;
  try {
    
(function() {
  var burger = document.getElementById('rf-burger-btn');
  var drawer = document.getElementById('rf-mobile-drawer');
  var close = document.getElementById('rf-drawer-close');
  var backdrop = document.getElementById('rf-drawer-backdrop');
  if (!burger || !drawer) return;
  function open() {
    drawer.classList.add('open');
    backdrop.classList.add('open');
    document.body.classList.add('rf-drawer-locked');
  }
  function shut() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.classList.remove('rf-drawer-locked');
  }
  burger.addEventListener('click', open);
  if (close) close.addEventListener('click', shut);
  if (backdrop) backdrop.addEventListener('click', shut);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') shut(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-hero-slider"]) return;
  try {
    
(function() {
  var timers = document.querySelectorAll('.timer[data-hero-timer]');
  if (!timers.length) return;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function endFor(el) {
    var loopHours = parseFloat(el.getAttribute('data-hero-loop-hours')) || 0;
    if (loopHours > 0) {
      var loopMs = loopHours * 3600000;
      return (Math.floor(Date.now() / loopMs) + 1) * loopMs;
    }
    var t = new Date(el.getAttribute('data-hero-timer')).getTime();
    return isNaN(t) ? null : t;
  }
  function update() {
    timers.forEach(function(el) {
      var end = endFor(el);
      if (end === null) return;
      var diff = end - Date.now();
      if (diff <= 0) {
        // If looping, endFor() on the next tick will yield a fresh window automatically.
        var loopHours = parseFloat(el.getAttribute('data-hero-loop-hours')) || 0;
        if (loopHours <= 0) { el.textContent = '00:00:00'; return; }
        end = endFor(el);
        diff = end - Date.now();
      }
      var totalHours = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = pad(totalHours) + ':' + pad(m) + ':' + pad(s);
    });
  }
  update();
  setInterval(update, 1000);
})();

(function () {
  // The dots existed but nothing drove them, so extra slides simply stacked
  // down the page. This makes the hero an actual carousel: one slide visible,
  // dots to jump, and a slow auto-advance that pauses on hover and is skipped
  // entirely for anyone who prefers reduced motion.
  var root   = document.querySelector('.hero-slider');
  if (!root) return;
  var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
  var dots   = Array.prototype.slice.call(root.querySelectorAll('.slider-dot'));
  if (slides.length < 2) return;

  var i = 0, timer = null;
  var DWELL = 6500;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    dots.forEach(function (d, k) {
      d.classList.toggle('active', k === i);
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
  }
  function play()  { if (!reduce) { stop(); timer = setInterval(function () { show(i + 1); }, DWELL); } }
  function stop()  { if (timer) { clearInterval(timer); timer = null; } }

  dots.forEach(function (d, k) {
    d.addEventListener('click', function () { show(k); play(); });
  });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', play);
  root.addEventListener('focusin', stop);

  show(0);
  play();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-main-cart"]) return;
  try {
    
function rfUpdateQty(line, delta) {
  const input = document.querySelector(`#rf-cart-form .qty-num[data-line="${line}"]`);
  if (!input) return;
  const val = Math.max(0, (parseInt(input.value) || 0) + delta);
  input.value = val;
  document.getElementById('rf-cart-form').submit();
}
function rfRemove(line) {
  const input = document.querySelector(`#rf-cart-form .qty-num[data-line="${line}"]`);
  if (!input) return;
  input.value = 0;
  document.getElementById('rf-cart-form').submit();
}
window.rfUpdateQty = rfUpdateQty;
window.rfRemove = rfRemove;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-main-product"]) return;
  try {
    
async function rfBuyNow(e) {
  e.preventDefault();
  const form = document.getElementById('rf-product-form');
  if (!form) return;
  const data = new FormData(form);
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', body: data });
    if (r.ok) { window.location.href = '/checkout'; }
    else { form.submit(); }
  } catch (_) { form.submit(); }
}
window.rfBuyNow = rfBuyNow;

function rfQty(delta) {
  const input = document.getElementById('rf-qty-input');
  if (!input) return;
  let val = parseInt(input.value) || 1;
  val = Math.max(1, Math.min(99, val + delta));
  input.value = val;
}
window.rfQty = rfQty;

(function() {
  const variantData = JSON.parse(document.getElementById('rf-variant-data').textContent);
  const form = document.getElementById('rf-product-form');
  if (!form || !variantData.length) return;
  const variantIdInput = document.getElementById('rf-variant-id');
  const priceCurrent = document.getElementById('rf-price-current');
  const priceStrike = document.getElementById('rf-price-strike');
  const priceSave = document.getElementById('rf-price-save');
  const atbPrice = document.getElementById('rf-atb-price');
  const mainImage = document.getElementById('rf-main-product-image');
  const skuText = document.querySelector('.sku-text');

  function money(v) { return '£' + (v / 100).toFixed(2); }

  function findVariant() {
    const selected = [];
    form.querySelectorAll('[data-option-index]').forEach(el => {
      const idx = el.getAttribute('data-option-index');
      const active = el.querySelector('.swatch.active, .size-option.active');
      if (active) selected[idx] = active.getAttribute('data-value');
    });
    return variantData.find(v => v.options.every((opt, i) => opt === selected[i]));
  }

  function update() {
    const v = findVariant();
    if (!v) return;
    variantIdInput.value = v.id;
    if (priceCurrent) priceCurrent.textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (priceStrike) priceStrike.textContent = money(v.compare_at_price);
      if (priceSave) priceSave.textContent = 'SAVE ' + money(v.compare_at_price - v.price);
    }
    if (atbPrice) atbPrice.textContent = money(v.price);
    /* The SKU is printed server-side from the variant the page opened on, and
       nothing was updating it — so on a product sold in several colours and
       sizes the code shown belonged to whatever loaded first. Keep it in step,
       and carry the alt text across with the image so the colour filter and
       screen readers both stay correct. */
    if (skuText) skuText.textContent = v.sku ? 'SKU: ' + v.sku : '';
    if (v.featured_image && mainImage) {
      mainImage.src = v.featured_image.src;
      if (v.featured_image.alt) {
        mainImage.alt = v.featured_image.alt;
        mainImage.setAttribute('data-colour', v.featured_image.alt.split(' · ')[0].trim());
      }
    }
  }

  form.querySelectorAll('.swatch, .size-option').forEach(btn => {
    btn.addEventListener('click', e => {
      if (btn.disabled) return;
      const block = btn.closest('.option-block');
      block.querySelectorAll('.swatch, .size-option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const selected = block.querySelector('.selected');
      if (selected) selected.textContent = '— ' + btn.getAttribute('data-value');
      update();
      if (btn.classList.contains('swatch')) filterByColour(btn.getAttribute('data-value'));
    });
  });

  // Thumbnail swap
  document.querySelectorAll('.thumb-rail button').forEach(btn => {
    btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-src');
      if (src && mainImage) mainImage.src = src;
      document.querySelectorAll('.thumb-rail button').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // Thumb rail arrows: scroll one viewport-width at a time
  document.querySelectorAll('.thumb-rail-wrap').forEach(wrap => {
    const rail = wrap.querySelector('.thumb-rail');
    const prev = wrap.querySelector('.thumb-rail-arrow.prev');
    const next = wrap.querySelector('.thumb-rail-arrow.next');
    if (!rail) return;
    function step() { return Math.max(rail.clientWidth - 40, 200); }
    function update() {
      if (!prev || !next) return;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', () => { rail.scrollBy({left: -step(), behavior: 'smooth'}); });
    if (next) next.addEventListener('click', () => { rail.scrollBy({left:  step(), behavior: 'smooth'}); });
    rail.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  });

  // ---- Colour gallery filter: clicking a colour shows only that colour's photos ----
  const thumbButtons = Array.from(document.querySelectorAll('.thumb-rail button'));
  const colourSwatches = Array.from(form.querySelectorAll('.swatch'));
  const colourValues = colourSwatches.map(s => s.getAttribute('data-value'));

  function filterByColour(colour) {
    if (!colour || colourValues.length < 2) return;
    const matches = thumbButtons.filter(b => b.getAttribute('data-colour') === colour);
    const shared  = thumbButtons.filter(b => colourValues.indexOf(b.getAttribute('data-colour')) === -1);

    // When a colour has no photo of its own, the old behaviour was to show
    // EVERY image — which meant picking "Orange" displayed the red, blue and
    // grey rugs. Showing another colour is worse than showing little, so fall
    // back to the generic shots only, and to a single image if there are none.
    if (!matches.length) {
      const fallback = shared.length ? shared : thumbButtons.slice(0, 1);
      thumbButtons.forEach(b => { b.style.display = fallback.indexOf(b) === -1 ? 'none' : ''; });
      if (mainImage && fallback[0]) {
        mainImage.src = fallback[0].getAttribute('data-src');
        thumbButtons.forEach(b => b.classList.remove('active'));
        fallback[0].classList.add('active');
      }
      return;
    }

    // A colour that DOES have its own photos shows only those. Generic shots are
    // hidden here too: they are a specific rug in a specific colour, so leaving
    // them visible is how a navy photo turned up under "Red".
    thumbButtons.forEach(b => {
      b.style.display = (b.getAttribute('data-colour') === colour) ? '' : 'none';
    });
    // Open on the room shot when this colour has one — it is the second image
    // per colour, and landing on it saves the customer a click.
    const pick = matches.find(b => b.getAttribute('data-room') === '1') || matches[0];
    if (mainImage) {
      mainImage.src = pick.getAttribute('data-src');
      thumbButtons.forEach(b => b.classList.remove('active'));
      pick.classList.add('active');
    }
    const rail = document.getElementById('rf-thumb-rail');
    if (rail) rail.scrollLeft = 0;
  }

  // On load, sync the gallery to a colour. If opened via ?variant= (e.g. a per-colour
  // collection card), honour that variant's colour; otherwise use the hero image's colour.
  if (colourValues.length >= 2) {
    const hasVariantParam = new URLSearchParams(location.search).has('variant');
    const activeSwatch = form.querySelector('.swatch.active');
    const heroColour = mainImage ? mainImage.getAttribute('data-colour') : '';
    let startColour;
    if (hasVariantParam && activeSwatch) {
      startColour = activeSwatch.getAttribute('data-value');
    } else if (heroColour && colourValues.indexOf(heroColour) !== -1) {
      startColour = heroColour;
    } else {
      startColour = activeSwatch ? activeSwatch.getAttribute('data-value') : colourValues[0];
    }
    if (startColour) {
      colourSwatches.forEach(s => s.classList.toggle('active', s.getAttribute('data-value') === startColour));
      const cblock = colourSwatches[0] ? colourSwatches[0].closest('.option-block') : null;
      const sel = cblock ? cblock.querySelector('.selected') : null;
      if (sel) sel.textContent = '— ' + startColour;
      update();
      filterByColour(startColour);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-new-arrivals"] && !Shopify.designMode) return;
  try {
    
/* Arrows only. The track scrolls natively without any of this, which is what
   phones get; this adds desktop buttons and disables them at each end. */
(function () {
  function wire(section) {
    var track = section.querySelector('[data-na-track]');
    var bar = section.querySelector('[data-na-arrows]');
    if (!track || !bar) return;
    var prev = section.querySelector('[data-na-prev]');
    var next = section.querySelector('[data-na-next]');

    function step() {
      var card = track.querySelector('.rf-na-item');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      var per = Math.max(1, Math.floor(track.clientWidth / (card.offsetWidth + gap)) - 1);
      return (card.offsetWidth + gap) * per;
    }
    function sync() {
      var over = track.scrollWidth - track.clientWidth > 4;
      bar.hidden = !over;
      if (!over) return;
      var x = track.scrollLeft;
      prev.disabled = x < 4;
      next.disabled = x > track.scrollWidth - track.clientWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    /* Images change the track width as they load. */
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
  }
  document.querySelectorAll('.rf-new-arrivals').forEach(wire);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('.rf-new-arrivals')) {
      e.target.querySelectorAll('.rf-new-arrivals').forEach(wire);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-product-details-tabs"]) return;
  try {
    
document.querySelectorAll('.details-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.getAttribute('data-target');
    document.querySelectorAll('.details-tab').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.details-panel').forEach(p => p.classList.remove('active'));
    tab.classList.add('active');
    const panel = document.getElementById('rf-tab-' + target);
    if (panel) panel.classList.add('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-sale-countdown"]) return;
  try {
    
(function() {
  var root = document.querySelector('.countdown[data-end-date]');
  if (!root) return;
  var endRaw = root.getAttribute('data-end-date');
  var loopHours = parseFloat(root.getAttribute('data-loop-hours')) || 0;
  var loopMs = loopHours * 3600000;
  var end;
  // Rolling mode: when loop_hours is set, ignore static end_date and anchor to a
  // fixed epoch grid so every visitor sees the same countdown.
  function rollingEnd() { return (Math.floor(Date.now() / loopMs) + 1) * loopMs; }
  if (loopMs > 0) {
    end = rollingEnd();
  } else if (endRaw) {
    end = new Date(endRaw).getTime();
    if (isNaN(end)) return;
  } else {
    return;
  }
  var unitEls = {};
  root.querySelectorAll('.num[data-unit]').forEach(function(el) { unitEls[el.getAttribute('data-unit')] = el; });
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var diff = end - Date.now();
    if (diff <= 0) {
      if (loopMs > 0) {
        end = rollingEnd();
        diff = end - Date.now();
      } else {
        Object.values(unitEls).forEach(function(el) { el.textContent = '00'; });
        clearInterval(timer);
        return;
      }
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (unitEls.days) unitEls.days.textContent = pad(d);
    if (unitEls.hours) unitEls.hours.textContent = pad(h);
    if (unitEls.minutes) unitEls.minutes.textContent = pad(m);
    if (unitEls.seconds) unitEls.seconds.textContent = pad(s);
  }
  tick();
  var timer = setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-search-main"]) return;
  try {
    
// Within-page sort: highest stock first. Only runs when no explicit sort_by param.
(function() {
  var grid = document.getElementById('rf-products');
  if (!grid) return;
  var params = new URLSearchParams(window.location.search);
  if (params.get('sort_by')) return;
  var wraps = Array.prototype.slice.call(grid.querySelectorAll('.rf-product-wrap'));
  wraps.sort(function(a, b) {
    var aStock = parseInt(a.getAttribute('data-stock'), 10) || 0;
    var bStock = parseInt(b.getAttribute('data-stock'), 10) || 0;
    return bStock - aStock;
  });
  var frag = document.createDocumentFragment();
  wraps.forEach(function(w) { frag.appendChild(w); });
  grid.appendChild(frag);
})();

(function() {
  var form = document.getElementById('rf-filter-form');
  var products = document.querySelectorAll('.rf-product-wrap');
  var emptyMsg = document.getElementById('rf-empty-msg');
  var countEl = document.getElementById('rf-visible-count');
  var totalEl = document.getElementById('rf-total-count');
  var clearBtn = document.getElementById('rf-clear-filters');
  var emptyClear = document.getElementById('rf-empty-clear');
  if (!form || !products.length) return;
  if (totalEl) totalEl.textContent = products.length;

  function applyFilters() {
    var checkedTags = [];
    var checkedColours = [];
    var checkedMaterials = [];
    var minPrice = parseFloat(document.getElementById('rf-price-min').value) || null;
    var maxPrice = parseFloat(document.getElementById('rf-price-max').value) || null;
    var saleOnly = false;

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
      var type = cb.getAttribute('data-rf-filter');
      var val = cb.value.toLowerCase();
      if (type === 'tag') checkedTags.push(val);
      else if (type === 'colour') checkedColours.push(val);
      else if (type === 'material') checkedMaterials.push(val);
      else if (type === 'sale') saleOnly = true;
    });

    var visible = 0;
    products.forEach(function(wrap) {
      var tags = wrap.getAttribute('data-tags').split('||');
      var colour = wrap.getAttribute('data-colour') || '';
      var price = parseFloat(wrap.getAttribute('data-price')) || 0;
      var onSale = wrap.getAttribute('data-on-sale') === '1';

      var show = true;
      if (checkedTags.length && !checkedTags.some(function(t) { return tags.indexOf(t) !== -1; })) show = false;
      if (checkedColours.length && !checkedColours.some(function(c) { return colour.indexOf(c) !== -1; })) show = false;
      if (minPrice !== null && price < minPrice) show = false;
      if (maxPrice !== null && price > maxPrice) show = false;
      if (saleOnly && !onSale) show = false;

      wrap.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (countEl) countEl.textContent = visible;
    if (emptyMsg) emptyMsg.style.display = visible === 0 ? 'block' : 'none';
    updateUrl();
  }

  function updateUrl() {
    var params = new URLSearchParams();
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
      params.append(cb.getAttribute('data-rf-filter'), cb.value);
    });
    var min = document.getElementById('rf-price-min').value;
    var max = document.getElementById('rf-price-max').value;
    if (min) params.append('price-min', min);
    if (max) params.append('price-max', max);
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.replaceState({}, '', newUrl);
  }

  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      var type = cb.getAttribute('data-rf-filter');
      var values = params.getAll(type);
      if (values.indexOf(cb.value) !== -1) {
        cb.checked = true;
        var label = cb.closest('.filter-option');
        if (label) label.classList.add('checked');
        var wrap = cb.closest('.colour-filter-wrap');
        if (wrap) wrap.classList.add('active');
      }
    });
    var min = params.get('price-min'), max = params.get('price-max');
    if (min) document.getElementById('rf-price-min').value = min;
    if (max) document.getElementById('rf-price-max').value = max;
  }

  function clearAll(e) {
    if (e) e.preventDefault();
    form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      cb.checked = false;
      var label = cb.closest('.filter-option');
      if (label) label.classList.remove('checked');
      var wrap = cb.closest('.colour-filter-wrap');
      if (wrap) wrap.classList.remove('active');
    });
    document.getElementById('rf-price-min').value = '';
    document.getElementById('rf-price-max').value = '';
    applyFilters();
  }

  // Wire events
  form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
    cb.addEventListener('change', function() {
      var label = cb.closest('.filter-option');
      if (label) label.classList.toggle('checked', cb.checked);
      var wrap = cb.closest('.colour-filter-wrap');
      if (wrap) wrap.classList.toggle('active', cb.checked);
      applyFilters();
    });
  });
  ['rf-price-min', 'rf-price-max'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', applyFilters);
  });
  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  if (emptyClear) emptyClear.addEventListener('click', clearAll);

  // Init
  readUrl();
  applyFilters();
})();

(function() {
  var toggle = document.getElementById('rf-filter-toggle');
  var sidebar = document.getElementById('rf-filter-sidebar');
  if (!toggle || !sidebar) return;
  toggle.addEventListener('click', function() {
    sidebar.classList.toggle('open');
    document.body.classList.toggle('rf-drawer-locked', sidebar.classList.contains('open'));
  });
  document.addEventListener('click', function(e) {
    if (sidebar.classList.contains('open') && !sidebar.contains(e.target) && e.target !== toggle && !toggle.contains(e.target)) {
      sidebar.classList.remove('open');
      document.body.classList.remove('rf-drawer-locked');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-sticky-product-bar"]) return;
  try {
    
(function() {
  var bar = document.getElementById('rf-sticky-bar');
  if (!bar) return;
  // Trigger anchor: the Add to Bag button (or the price block if button missing)
  function anchor() {
    return document.querySelector('.add-to-bag') || document.querySelector('.price-block') || document.querySelector('.product-detail');
  }
  function onScroll() {
    var el = anchor();
    if (!el) return;
    var rect = el.getBoundingClientRect();
    // Show when anchor's bottom has scrolled past top of viewport
    if (rect.bottom < 0) {
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', onScroll);
  onScroll();
})();

  } catch(e) { console.error(e); }
})();
})();
